import { isMapSlug } from "@/lib/maps/mountain-map-share";

export type MountainFeedbackContext = {
  resort: string;
  sport: "ski" | "mtb";
  source: "map" | "route";
};

/** Public browsing context only. Never attach personal routes, GPS or crew data. */
export function parseMountainFeedbackContext(raw: unknown): MountainFeedbackContext | null {
  let value = raw;
  if (typeof raw === "string") {
    if (raw.length > 400) return null;
    try { value = JSON.parse(raw); } catch { return null; }
  }
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const context = value as Record<string, unknown>;
  if (Object.keys(context).some(key => !["resort", "sport", "source"].includes(key)) ||
    !isMapSlug(context.resort) ||
    (context.sport !== "ski" && context.sport !== "mtb") ||
    (context.source !== "map" && context.source !== "route")) return null;
  return { resort: context.resort, sport: context.sport, source: context.source };
}

export function mountainFeedbackFromSearch(search: string): MountainFeedbackContext | null {
  const params = new URLSearchParams(search);
  if (params.get("context") !== "mountain-feedback" ||
    ["context", "resort", "sport", "source"].some(key => params.getAll(key).length !== 1)) return null;
  return parseMountainFeedbackContext({ resort: params.get("resort"), sport: params.get("sport"), source: params.get("source") });
}

export function mountainFeedbackPath(context: MountainFeedbackContext): string {
  const safe = parseMountainFeedbackContext(context);
  return safe ? `/feedback?${new URLSearchParams({ context: "mountain-feedback", ...safe })}` : "/feedback";
}

export function mountainFeedbackLabel(context: MountainFeedbackContext): string {
  const resort = context.resort.split("-").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
  return `${resort} · ${context.sport === "ski" ? "Ski" : "MTB"} ${context.source === "map" ? "map" : "route planner"}`;
}

export function mountainFeedbackReturnPath(context: MountainFeedbackContext): string {
  return `/conditions/${context.resort}?sport=${context.sport === "ski" ? "piste" : "mtb"}&tab=map#location-sections`;
}
